import store from '@/store/store';

export default function estDemandeManuelle() {
  const societe = store.getters['societe/societeActive'];
  const demandeur = store.getters['user/user'];
  if (!societe || (demandeur.id !== null
    && societe.utilisateursDemandeTempoManuelleAPrevenir.includes(demandeur.id))) {
    return false;
  }
  return societe.gestionDemandeTempoManuelle
    || (demandeur.id !== null && societe.utilisateursDemandeTempoManuelle.includes(demandeur.id));
}
